import { ActionBase } from '../../../core/store/action/ActionBase';
import { DateFramedMessageModel } from '../../models/DateFramedMessageModel';

export const ACTIVATE_DRAFT_BROADCAST_MESSAGE_SUCCESS_ACTION = '[Configuration] Messages Activate Draft Broadcast Message Success Action';

export class ActivateDraftBroadcastMessageSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ACTIVATE_DRAFT_BROADCAST_MESSAGE_SUCCESS_ACTION;

  constructor(public payload: { activatedBroadcast: DateFramedMessageModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/messages/store/actions/ActivateDraftBroadcastMessageSuccessAction.ts